<template>
    <b-card class="mb-4" no-header>
      <!-- <template #header>
        <b-row>
          <b-col cols="12">
            <h5 class="mb-0">{{ $route.meta.title }}</h5>
          </b-col>
        </b-row>
      </template> -->
      <b-row>
        <b-col cols="12" class="mb-4">
          <b-form @submit.prevent="doFilter">
            <b-row class="filter-row">
              <b-col cols="6" md="3">
                <form-group-input
                  ref="filter-year"
                  type="enum"
                  :clearable="false"
                  :options="list.year"
                  placeholder="Pilih Tahun"
                  :need-label="true"
                  label="Tahun"
                  v-model="filter.year_period"
                  id="filter-year"
                />
              </b-col>
              <b-col cols="6" md="3">
                <form-group-input
                  ref="filter-school_name"
                  type="text"
                  placeholder="Nama Sekolah"
                  :need-label="true"
                  label="Nama Sekolah"
                  v-model="filter.school_name"
                  id="filter-school_name"
                />
              </b-col>
              <b-col cols="6" md="2">
                <label class="form-label">&nbsp;</label><br />
                <b-btn type="submit" class="btn-in-form" variant="primary">
                  <font-awesome-icon icon="search" /><span>Cari</span>
                </b-btn>
                <b-btn
                  type="button"
                  @click.prevent="clearForm"
                  variant="secondary"
                  class="btn-in-form ml-2"
                >
                  <font-awesome-icon icon="broom" /><span>Clear</span>
                </b-btn>
              </b-col>
              <b-col cols="4" class="text-right">
                <label class="form-label">&nbsp;</label><br />
                <b-btn type="button" to="/import-anggaran" class="btn-in-form" variant="primary">
                  <span>Import Anggaran</span>
                </b-btn>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
      <paginated-table
        ref="dataTable"
        :no-actions="true"
        :data-url="apiUrl.school"
        :data-columns="columns"
        :dataParams="dataParams"
        :defaultDataParams="this.filter"
      >
        <template slot="content_aggaran_sem_1" slot-scope="defaultSlotScope">
          <span
            style="text-transform: uppercase"
            v-if="defaultSlotScope.colData.budget !== null"
          >
            bos reguler: rp.
            {{
              $formatPrice(
                defaultSlotScope.colData.budget.first_step_details["bos-reguler"]
              )
            }}
            <br />
            bos kinerja: rp.
            {{
              $formatPrice(
                defaultSlotScope.colData.budget.first_step_details["bos-kinerja"]
              )
            }}
            <br />
            bos paud: rp.
            {{
              $formatPrice(
                defaultSlotScope.colData.budget.first_step_details["bos-paud"]
              )
            }}
            <br />
            bos silpa: rp.
            {{
              $formatPrice(
                defaultSlotScope.colData.budget.first_step_details["bos-silpa"]
              )
            }}
            <br />
            bos daerah: rp.
            {{
              $formatPrice(
                defaultSlotScope.colData.budget.first_step_details["bosda"]
              )
            }}
            <br />
            <strong>total: rp.
            {{ $formatPrice(defaultSlotScope.colData.budget.first_step_total) }}</strong>
          </span>
  
          <span v-else>
            -
            <!-- <a
              href="javascript:void(0);"
              v-b-modal="'anggaran_sem_1_' + defaultSlotScope.colData.id"
              >Tambah Anggaran</a -->
            </span>
          <!-- <b-modal
            :id="'anggaran_sem_1_' + defaultSlotScope.colData.id"
            title="Tambah Anggaran"
            hide-footer
          >
            <b-form @submit.prevent="saveAnggaranSmester1(defaultSlotScope.colData.id)">
              <b-row>
                <b-col md="4">
                  <formGroupInput
                    type="price"
                    v-model="anggaran_sem_1.bos_reguler"
                    placeholder="Masukkan anggaran"
                    label="Bos Reguler"
                    id="bos_reguler"
                    :need-label="true"
                  />
                </b-col>
                <b-col md="4">
                  <formGroupInput
                    type="price"
                    v-model="anggaran_sem_1.bos_kinerja"
                    placeholder="Masukkan anggaran"
                    label="Bos Kinerja"
                    id="bos_kinerja"
                    :need-label="true"
                  />
                </b-col>
                <b-col md="4">
                  <formGroupInput
                    type="price"
                    v-model="anggaran_sem_1.bos_paud"
                    placeholder="Masukkan anggaran"
                    label="Bos Paud"
                    id="bos_paud"
                    :need-label="true"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <formGroupInput
                    type="price"
                    v-model="anggaran_sem_1.bos_silpa"
                    placeholder="Masukkan anggaran"
                    label="Bos Silpa"
                    id="bos_silpa"
                    :need-label="true"
                  />
                </b-col>
                <b-col md="6">
                  <formGroupInput
                    type="price"
                    v-model="anggaran_sem_1.bos_daerah"
                    placeholder="Masukkan anggaran"
                    label="Bos Daerah"
                    id="bos_daerah"
                    :need-label="true"
                  />
                </b-col>
              </b-row>
              <hr />
              <p class="text-right">
                Total Anggaran: Rp. {{ $formatPrice(totalAnggaranSmester1) }}
              </p>
              <b-button
                type="submit"
                variant="primary"
                class="float-right"
                >Simpan</b-button
              >
            </b-form>
          </b-modal> -->
        </template>
        <template slot="content_aggaran_sem_2" slot-scope="defaultSlotScope">
          <div v-if="defaultSlotScope.colData.budget">
            <span
              style="text-transform: uppercase"
              v-if="defaultSlotScope.colData.budget.second_step_details !== null"
            >
              bos reguler: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.second_step_details[
                    "bos-reguler"
                  ]
                )
              }}
              <br />
              bos kinerja: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.second_step_details[
                    "bos-kinerja"
                  ]
                )
              }}
              <br />
              bos paud: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.second_step_details["bos-paud"]
                )
              }}
              <br />
              bos silpa: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.second_step_details["bos-silpa"]
                )
              }}
              <br />
              bos daerah: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.second_step_details["bosda"]
                )
              }}
              <br />
              <strong>total: rp.
            {{ $formatPrice(defaultSlotScope.colData.budget.second_step_total) }}</strong>
            </span>
  
            <span v-else> - </span>
          </div>
  
          <div v-else>-</div>
        </template>
        <template slot="content_total_anggaran" slot-scope="defaultSlotScope">
          <div v-if="defaultSlotScope.colData.budget">
            <span
              style="text-transform: uppercase"
              v-if="defaultSlotScope.colData.budget.total_details !== null"
            >
              bos reguler: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.total_details["bos-reguler"]
                )
              }}
              <br />
              bos kinerja: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.total_details["bos-kinerja"]
                )
              }}
              <br />
              bos paud: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.total_details["bos-paud"]
                )
              }}
              <br />
              bos silpa: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.total_details["bos-silpa"]
                )
              }}
              <br />
              bos daerah: rp.
              {{
                $formatPrice(
                  defaultSlotScope.colData.budget.total_details["bosda"]
                )
              }}
              <br />

              <strong>total: rp.
            {{ $formatPrice(defaultSlotScope.colData.budget.total) }}</strong>
            </span>
  
            <span v-else> - </span>
          </div>
  
          <div v-else>-</div>
        </template>
        <template slot="content_realisasi_sem_1" slot-scope="defaultSlotScope">
          <div v-if="defaultSlotScope.colData.budget">
            <span style="text-transform: uppercase">
              bos reguler: rp. {{ $formatPrice(0) }} <br />
              bos kinerja: rp. {{ $formatPrice(0) }} <br />
              bos paud: rp. {{ $formatPrice(0) }} <br />
              bos silpa: rp. {{ $formatPrice(0) }} <br />
              bos daerah: rp. {{ $formatPrice(0) }} <br />
              <strong>total: rp. {{ $formatPrice(0) }}</strong>
            </span>
          </div>
  
          <div v-else>-</div>
        </template>
        <template slot="content_realisasi_sem_2" slot-scope="defaultSlotScope">
          <div v-if="defaultSlotScope.colData.budget">
            <span style="text-transform: uppercase">
              bos reguler: rp. {{ $formatPrice(0) }} <br />
              bos kinerja: rp. {{ $formatPrice(0) }} <br />
              bos paud: rp. {{ $formatPrice(0) }} <br />
              bos silpa: rp. {{ $formatPrice(0) }} <br />
              bos daerah: rp. {{ $formatPrice(0) }} <br />
              <strong>total: rp. {{ $formatPrice(0) }}</strong>
            </span>
          </div>
  
          <div v-else>-</div>
        </template>
        <template slot="content_rasio" slot-scope="defaultSlotScope">
          0%
        </template>
      </paginated-table>
    </b-card>
  </template>
  
  <script>
  import { objectToOptions } from "@/_helpers";
  // import { objectToOptions, getYears, formatModelValue } from '@/_helpers'
  import paginatedTable from "@/components/PaginatedTable.vue";
  import formGroupInput from "@/components/FormGroupInput.vue";
  import School from "@/models/School.js";
  
  const schoolModel = new School();
  
  export default {
    components: {
      formGroupInput,
      paginatedTable,
    },
    data() {
      return {
        isLoading: false,
        totalPromiseAreaCount: 0,
        current_year: new Date().getFullYear(),
        anggaran_sem_1: {
          bos_reguler: "0",
          bos_kinerja: "0",
          bos_paud: "0",
          bos_silpa: "0",
          bos_daerah: "0",
        },
        total_anggaran_sem_1: 0,
        apiUrl: {
          school: schoolModel.endpoint,
          school_budget: schoolModel.endpoint + "/budget-list",
        },
        columns: [
          {
            prop: "school_name",
            label: "Nama sekolah",
            sortable: true,
            resizable: true,
            minWidth: 160,
          },
          {
            prop: "npsn",
            label: "NPSN",
            sortable: true,
            resizable: true,
            minWidth: 160,
          },
          {
            prop: "aggaran_sem_1",
            label: "Anggaran Semester 1",
            sortable: false,
            resizable: true,
            minWidth: 300,
          },
          {
            prop: "aggaran_sem_2",
            label: "Anggaran Semester 2",
            sortable: false,
            resizable: true,
            minWidth: 300,
          },
          {
            prop: "total_anggaran",
            label: "Total Anggaran",
            sortable: false,
            resizable: true,
            minWidth: 300,
          },
          {
            prop: "realisasi_sem_1",
            label: "Realisasi Semester 1",
            sortable: false,
            resizable: true,
            minWidth: 300,
          },
          {
            prop: "realisasi_sem_2",
            label: "Realisasi Semester 2",
            sortable: false,
            resizable: true,
            minWidth: 300,
          },
          {
            prop: "rasio",
            label: "Rasio",
            sortable: false,
            resizable: true,
            minWidth: 160,
          },
        ],
        list: {
          year: [],
        },
        filter: {
          with_budget: 1,
          with_stats: 1,
          year_period: this.$route.query.year_period ?? new Date().getFullYear(),
          school_name: this.$route.query.school_name ?? null
        },
        dataParams: ["with_budget", "with_stats", "year_period", "school_name"],
      };
    },
    // beforeMount() {
    //   this.$router
    //     .push({
    //       query: { ...this.$route.query, ...{ with_budget: 1, with_stats: 1 } },
    //     })
    //     .catch((err) => {});
    // },
    mounted() {
      this.getYearPeriod()
    },
    watch: {},
    computed: {
      totalAnggaranSmester1: function () {
        this.total_anggaran_sem_1 = Object.values(this.anggaran_sem_1).reduce(
          (accumuator, value) => {
            return accumuator + this.$priceToInt(value);
          },
          0
        );
  
        return this.total_anggaran_sem_1;
      },
    },
    methods: {
      getYearPeriod() {
        const year_start = 2023
        const year = this.current_year
  
        const years = {};
        for (let i = year_start; i <= year; i++) {
          years[i] = i
        }
  
        this.list.year = objectToOptions(years)
      },
      clearForm() {
        this.$nextTick(() => {
          this.filter.year = null
          this.filter.school_name = null
          setTimeout(() => {
            this.doFilter();
          }, 100);
        });
      },
      doFilter() {
        this.$refs.dataTable.doFilter(this.filter);
      },
      doExport() {
        if (this.isLoading) {
          return false;
        }
        this.isLoading = true;
        const filterArray = [];
        Object.keys(this.filter).forEach((key) => {
          if (this.filter[key]) {
            filterArray.push(key + "=" + this.filter[key]);
          }
        });
        filterArray.push("csv=1");
  
        this.$http
          .get(dptModel.getEndpoint() + "?" + filterArray.join("&"))
          .then((response) => {
            const a = document.createElement("a");
  
            const blob = new Blob([response.data], { type: "octet/stream" });
            a.href = window.URL.createObjectURL(blob);
  
            a.download = "data_dpt.csv";
            a.click();
            this.isLoading = false;
          })
          .catch((error) => {
            this.$store.dispatch("notification/error", error);
            this.isLoading = false;
          });
      },
      saveAnggaranSmester1(id) {
        this.isLoading = true;
  
        this.$swal
          .fire({
            title: "Anda Yakin?",
            text: "Setelah ini sekolah akan ditambahkan anggaran!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya",
            cancelButtonText: "Tidak",
            // confirmButtonClass: 'btn btn-danger mr-3',
            // cancelButtonClass: 'btn btn-default',
            // buttonsStyling: false
          })
          .then((result) => {
            if (result.value) {
              this.$http
                .post(schoolModel.getEndpoint() + "/" + id + "/budget", {
                  total: this.total_anggaran_sem_1,
                  total_details: {
                    "bos-reguler": this.$priceToInt(
                      this.anggaran_sem_1.bos_reguler
                    ),
                    "bos-kinerja": this.$priceToInt(
                      this.anggaran_sem_1.bos_kinerja
                    ),
                    "bos-paud": this.$priceToInt(this.anggaran_sem_1.bos_paud),
                    "bos-silpa": this.$priceToInt(this.anggaran_sem_1.bos_silpa),
                    bosda: this.$priceToInt(this.anggaran_sem_1.bos_daerah),
                  },
                })
                .then((response) => {
                  this.$store.dispatch(
                    "notification/success",
                    "Berhasil mengubaha status menjadi direvisi."
                  );
                  this.$refs.dataTable.getDataTable();
                  this.anggaran_sem_1 = {};
                  this.total_anggaran_sem_1 = 0;
                  this.$bvModal.hide('anggaran_sem_1_' + id)
                  this.isLoading = false;
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$store.dispatch(
                    "notification/error",
                    "Gagal mengubaha status menjadi direvisi data."
                  );
                  console.log(error);
                });
            }
          });
      },
    },
  };
  </script>